import { Timestamp } from 'firebase/firestore';

export function serializeMessagingDocTimestamp(value: unknown): string | null {
  if (value == null || value === '') return null;
  if (value instanceof Timestamp) {
    return `${value.seconds}.${value.nanoseconds}`;
  }
  if (typeof value === 'object' && value !== null) {
    const t = value as {
      seconds?: number;
      nanoseconds?: number;
      _seconds?: number;
      _nanoseconds?: number;
      toMillis?: () => number;
    };
    if (typeof t.seconds === 'number') {
      return `${t.seconds}.${t.nanoseconds ?? 0}`;
    }
    if (typeof t._seconds === 'number') {
      return `${t._seconds}.${t._nanoseconds ?? 0}`;
    }
    if (typeof t.toMillis === 'function') {
      try {
        return `ms:${t.toMillis()}`;
      } catch {
        return null;
      }
    }
  }
  if (typeof value === 'string' || typeof value === 'number') {
    return String(value);
  }
  return null;
}

export function messagingDocTimestampMillis(value: unknown): number | null {
  if (value == null || value === '') return null;
  if (typeof value === 'number') return Math.floor(value);
  if (typeof value === 'string') {
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? null : parsed;
  }
  if (typeof value === 'object') {
    const t = value as { seconds?: number; nanoseconds?: number; _seconds?: number; _nanoseconds?: number };
    const seconds = t.seconds ?? t._seconds;
    if (typeof seconds === 'number') {
      return seconds * 1000 + Math.floor((t.nanoseconds ?? t._nanoseconds ?? 0) / 1e6);
    }
  }
  return null;
}
